import { Gondor } from "../Gondor";

const ACTIONS = {
  GENDER: "/gender/",
  GENDER_ITEM: "/gender/{id}/",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.GENDER, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.GENDER_ITEM.replace("{id}", id));
}

export function create(body: { [name: string]: string }) {
  const payload = { description: body.name };
  return Gondor.API.post(ACTIONS.GENDER, payload);
}

export function update(id: number | string, body: { [name: string]: string }) {
  id = id.toString();
  const payload = { description: body.name };
  return Gondor.API.patch(ACTIONS.GENDER_ITEM.replace("{id}", id), payload);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.GENDER_ITEM.replace("{id}", id));
}
